<ui-breadcrumb-nav ariaLabel="Breadcrumb">
  <ui-breadcrumb>
    <ui-skeleton class="block rounded-full h-5 w-5" />
  </ui-breadcrumb>
  <ui-breadcrumb>
    <ui-skeleton class="block rounded-full h-3 w-[74px]" />
  </ui-breadcrumb>
  <ui-breadcrumb>
    <ui-skeleton class="block rounded-full h-3 w-[74px]" />
  </ui-breadcrumb>
</ui-breadcrumb-nav>
